/* Inclusion
 *********************************************************************************************/
window.$ = window.jQuery = require('jquery');

require('../bootstrap');
require('eonasdan-bootstrap-datetimepicker');

require('./clickToTel');